var React = require('react');

function ProfileInput (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M32,14.05c-6.6,0-12,5.4-12,12s5.4,12,12,12,12-5.4,12-12-5.4-12-12-12ZM32,34.05c-4.4,0-8-3.6-8-8s3.6-8,8-8,8,3.6,8,8-3.6,8-8,8Z","key":0}),React.createElement("path",{"d":"M32,4.05c-15.5,0-28,12.5-28,28,0,7.6,3.1,14.6,8,19.6,1.2,1.2,2.5,2.3,4,3.3,4.5,3.2,10,5,16,5s11.5-1.9,16-5c1.4-1,2.7-2.1,4-3.3,5-5.1,8-12,8-19.6,0-15.5-12.5-28-28-28ZM32,56.05c-6,0-11.4-2.2-15.6-5.8,1.1-3.6,4.4-6.2,8.3-6.2h14.7c3.9,0,7.2,2.6,8.3,6.2-4.3,3.6-9.7,5.8-15.7,5.8ZM50.7,47.05c-2.1-4.2-6.4-7-11.3-7h-14.7c-5,0-9.3,2.9-11.3,7-3.4-4.1-5.4-9.3-5.4-15,0-13.2,10.8-24,24-24s24,10.8,24,24c0,5.7-2,10.9-5.3,15Z","key":1})]);
}

ProfileInput.defaultProps = {"id":"Layer_1","viewBox":"0 0 64 64"};

module.exports = ProfileInput;

ProfileInput.default = ProfileInput;
